export default __webpack_public_path__ + "static/media/rear.b2ecca89.png";